<div class="crowdctrl-form-submit-bar" role="group" aria-label="Form actions">
  <ng-content select="[crowdctrlFormSecondaryAction]"></ng-content>
  <ng-content select="[crowdctrlFormPrimaryAction]"></ng-content>
</div>
